import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchSelectService {
  readonly BASE_URL = environment.BASE_API_URL;
  searchSelectOpenedSignal = signal(false)  
  constructor(
    private http:HttpClient,
  ) { }
  getItems(type:string, filteringName:string|null=null):Observable<any>{
    let url:string = this.getUrl(type, filteringName)
    return this.http.get(url)
  }
  private getUrl(type:string, filteringName:string|null):string{
    let url:string = '';
    switch (type){
      case 'school':{
        url = `${this.BASE_URL}organ/?type=UN${filteringName?`&search=${filteringName}`:''}`
        break;
      }
      case 'organ':{
        url = `${this.BASE_URL}organ/${filteringName?`?search=${filteringName}`:''}`
        break;
      }
      case 'language':{
        url = `${this.BASE_URL}user_role/language/${filteringName?`?search=${filteringName}`:''}`
        break;
      }
      case 'field':{
        url = `${this.BASE_URL}user_role/generic_field/?type=STUDENT${filteringName?`&search=${filteringName}`:''}`
        break;
      }
      case 'software':{
        url = `${this.BASE_URL}user_role/generic_field/?type=SOFTWARE_SKILL${filteringName?`&search=${filteringName}`:''}`
        break;
      }
      case 'skill':{
        url = `${this.BASE_URL}user_role/generic_field/?type=SKILL${filteringName?`&search=${filteringName}`:''}`
        break;
      }
      case 'work_field':{
        url = `${this.BASE_URL}user_role/employee_field/list_allowed_field/${filteringName?`?search=${filteringName}`:''}`
        break;
      }
      default:{
        url = `${this.BASE_URL}place/city/${filteringName?`?search=${filteringName}`:''}`
        break;
      }
    }
    return url
  }
  createItem(type:string, f:FormData):Observable<any>{
    return this.http.post(this.postUrl(type), f)
  }
  private postUrl(type:string):string{
    let url:string = '';
    switch (type){
      case('organ'):{
        url = `${this.BASE_URL}user_role/employee_role/`
        break;
      }
      case('skill'):{
        url = `${this.BASE_URL}user_role/generic_field/`
        break;
      }
      case('software'):{
        url = `${this.BASE_URL}user_role/generic_field/`
        break;
      }
      default:{
        url = `${this.BASE_URL}user_role/employee_field/`
        break;
      }
    }
    return url
  }
}
